import React from "react";
import { cn } from "@/libs/utils";

/**
 * 제품 상세 섹션 간 세로 간격.
 *
 * 원래 `src/pages/tactsuit/tactsuit-air` 에 정의돼 있어서 컴포넌트가 페이지 모듈을
 * import 하는 역방향 의존이 있었다(#5068 통합으로 그 페이지가 리다이렉트 스텁이 되면
 * 깨진다). 공용 위치로 옮긴다.
 */
export const Gap = ({
  children,
  className,
}: React.PropsWithChildren<{ className?: string }>) => (
  <div className={cn("mt-16 laptop:mt-24", className)}>{children}</div>
);
